import type { GardenZone } from '@/types/plantTypes'

export interface GraduationAssessmentReward {
  stars: number
  plantExperience: number
}

interface RewardClaimBase {
  id: string
  status: 'pending' | 'completed'
  studentId: string
  stageId: string
  unitId: string
  stars: number
  starsGrantedAt: string
  plantExperienceGrantedAt?: string
  leaderboardProjectedAt?: string
  deliveryAttemptCount?: number
  lastDeliveryAttemptAt?: string
  lastDeliveryError?: string
  nextDeliveryAttemptAt?: string
  createdAt: string
  completedAt?: string
}

export interface GraduationRewardClaim extends RewardClaimBase {
  kind: 'graduation-assessment'
  assessmentSessionId: string
  plantExperience: number
}

export interface FormativeTaskReward {
  stars: number
  plantExperienceAwards: Partial<Record<GardenZone, number>>
}

export interface FormativeTaskRewardClaim extends RewardClaimBase {
  kind: 'formative-task'
  formativeTaskSessionId: string
  taskId: string
  plantExperienceAwards: Partial<Record<GardenZone, number>>
}

export interface LearningTaskRewardClaim extends RewardClaimBase {
  kind: 'learning-task'
  taskId: string
  plantExperienceAwards: Partial<Record<GardenZone, number>>
}

export type RewardClaim = GraduationRewardClaim | FormativeTaskRewardClaim | LearningTaskRewardClaim

export function findTaskRewardClaim(
  claims: RewardClaim[],
  input: { studentId: string; stageId: string; taskId: string },
): FormativeTaskRewardClaim | LearningTaskRewardClaim | undefined {
  return claims.find((claim): claim is FormativeTaskRewardClaim | LearningTaskRewardClaim => (
    claim.kind !== 'graduation-assessment'
    && claim.studentId === input.studentId
    && claim.stageId === input.stageId
    && claim.taskId === input.taskId
  ))
}

export function createGraduationRewardClaimId(studentId: string, stageId: string): string {
  return `graduation:${studentId}:${stageId}`
}

export function createFormativeTaskRewardClaimId(sessionId: string): string {
  return `formative-task:${sessionId}`
}

export function createLearningTaskRewardClaimId(
  studentId: string,
  stageId: string,
  taskId: string,
): string {
  return `learning-task:${encodeURIComponent(studentId)}:${encodeURIComponent(stageId)}:${encodeURIComponent(taskId)}`
}
